import { openInvoiceExecuteProjectChange, openInvoiceStartApproval, setInvoicePaid } from "@/Default/Documents/DocumentUIHelpers";
import { DocumentsInvoiceWorkflowGrid } from "@/Default/DocumentsInvoiceWorkflow/DocumentsInvoiceWorkflowGrid";
import { DocumentsInvoiceWorkflowInboxGrid } from "@/Default/DocumentsInvoiceWorkflow/DocumentsInvoiceWorkflowInboxGrid";
import { FunctionalUnitsRow, SettingsService, StatusRow, TypesRow } from "@/ServerTypes/Administration";
import { SettingsRow } from "@/ServerTypes/Administration/SettingsRow";
import { DocumentInvoiceDataForm, DocumentInvoiceDataRow, DocumentInvoiceDataService, DocumentsForm, DocumentsInvoiceWorkflowService, DocumentsRow } from "@/ServerTypes/Default";
import { Authorization, Criteria, EditorUtils, EntityDialog, EntityGrid, Fluent, LookupEditor, PropertyGrid, QuickSearchField, RetrieveResponse, Toolbar, any, confirmDialog, getForm, getType, localText, notifySuccess, serviceCall, tryFirst, tryGetText } from "@serenity-is/corelib";
import { actionsToolButton, makeReadOnly, undoMadeReadOnly } from "commonfeatures";

setTimeout(() => {
    Cemdo.DocumentManagement.Flags.disableAssignFolderTemplate = true;
    Cemdo.DocumentManagement.Flags.showProjectAndWbsElementOnDialog = true;
    setupDocumentManagementUIOverrides();

    const documentsGridType = getType("Cemdo.DocumentManagement.DocumentsGrid") as any;
    if (documentsGridType) {
        documentsGridType.IsLockEnabled = true;
        documentsGridType.IsDocumentPreviewEnabled = true;
        documentsGridType.IsOfficeDocumentPreviewEnabled = true;
        documentsGridType.IsReminderEnabled = true;

        if (Authorization.userDefinition && Authorization.userDefinition.UserId) {
            var setting = SettingsRow.getLookup().items.filter(x => x.Setting.toLowerCase() == "fulltextsearchenabled");
            if (setting.length > 0)
                documentsGridType.fullTextSearchEnabled = setting[0].Value == "true" ? true : false;
        }
    }
}, 0);

type DocumentsDialogExtended = EntityDialog<any, any> & {
    documentsInvoiceForm?: DocumentInvoiceDataForm;
    invoicePropertyGrid?: PropertyGrid;
    isChangeMode?: boolean;
    alreadyCheckedDocumentInbox?: boolean;
    isDocumentInbox?: boolean;
    toolbar?: Toolbar;
    form?: DocumentsForm;
    isEditMode(): boolean;
    isNew(): boolean;
    referencesExists?: boolean;
    alreadyAddedReminderMilestone?: boolean;
    invoiceTabAlreadyAdded?: boolean;
    byId?(id: string): Fluent;
}

type DocumentsGridExtended = EntityGrid<any, any> & {
}

export function setupDocumentManagementUIOverrides() {

    const documentsDialogProto = (getType("Cemdo.DocumentManagement.DocumentsDialog") as any)?.prototype;
    if (documentsDialogProto) {
        documentsDialogProto['getToolbarButtons'] = (function (old: any) {
            return function () {
                var buttons = old.call(this);
                var new_buttons = [];
                /* +++ OCT START ++++++++++++++++++++++++++++++++++++++++++++++++++ */

                // Add hidden button for Start Approval Invoice Workflow
                new_buttons.push({
                    title: localText('Site.DocumentsInvoiceWorkflow.StartApproval'),
                    cssClass: 'start-approval-button',
                    icon: 'fa fa-check-circle text-green',
                    visible: () => false,
                    onClick: () => {
                        var document;
                        DocumentsInvoiceWorkflowService.RetrieveByDocumentId({
                            EntityId: this.entityId
                        }, response => {
                            document = response;
                        }, {
                            async: false
                        });
                        openInvoiceStartApproval(document.Entity, this, () => this.dialogClose());
                    }
                });
                new_buttons.push({
                    title: localText('Site.DocumentsInvoiceWorkflow.ChangeProject'),
                    cssClass: 'change-project-button',
                    icon: 'fa fa-exchange text-green',
                    visible: () => false,
                    onClick: () => {
                        var document;
                        DocumentsInvoiceWorkflowService.RetrieveByDocumentId({
                            EntityId: this.entityId
                        }, response => {
                            document = response;
                        }, {
                            async: false
                        });
                        openInvoiceExecuteProjectChange(document.Entity, this, () => this.dialogClose());
                    }
                });
                new_buttons.push({
                    title: localText('Site.DocumentsInvoiceWorkflow.SetPayment'),
                    cssClass: 'set-payment-button',
                    icon: 'fa fa-money text-green',
                    visible: () => false,
                    onClick: () => {
                        var document;
                        DocumentsInvoiceWorkflowService.RetrieveByDocumentId({
                            EntityId: this.entityId
                        }, response => {
                            document = response;
                        }, {
                            async: false
                        });
                        setInvoicePaid(document.Entity, null, () => this.dialogClose());
                    }
                });
                // Hide Save and Update on intial view (as not edit-mode)
                // new_buttons[0].visible = () => this.isEditMode() && this.isChangeMode;
                // new_buttons[1].visible = () => this.isEditMode() && this.isChangeMode;
                // new_buttons[2].visible = () => this.isEditMode() && this.isChangeMode;
                buttons = buttons.concat(new_buttons);

                /* +++ OCT END ++++++++++++++++++++++++++++++++++++++++++++++++++ */


                
                return buttons;
            }
        })(documentsDialogProto['getToolbarButtons']);

        documentsDialogProto['initToolbar'] = (function (old: any) {
            return function () {
                old.call(this);
                this.isChangeMode = (this.isChangeMode == undefined) ? false : this.isChangeMode;
                this.toolbar.findButton('delete-button').remove();
                this.toolbar.findButton('save-and-close-button').visible = () => this.isEditMode() && this.isChangeMode;
                this.toolbar.findButton('apply-changes-button').visible = () => this.isEditMode() && this.isChangeMode;

                var buttons = [];

                buttons.push({
                    title: localText("Site.FileView.DecoupleButton"),
                    cssClass: "decouple-document-button",
                    visible: () => !this.isNew(),
                    onClick: () => {
                        confirmDialog(localText("Site.FileView.DecoupleConfirmQuestion"), () => {
                            serviceCall({
                                service: 'Default/Documents/DecoupleDocument',
                                request: {
                                    documentId: this.entityId
                                },
                                onSuccess: () => {
                                    notifySuccess(localText("Site.FileView.DecoupleSuccess"));
                                    this.dialogClose();
                                }
                            });
                        })
                    }
                });

                if (Authorization.hasPermission("Administration:Tenant")) {
                    buttons.push({
                        title: localText("Site.FileView.ExchangeExternalFileButton"),
                        cssClass: "exchange-external-document-button",
                        visible: () => !!this.entity.ExternalSource?.length,
                        onClick: () => {
                            confirmDialog(localText("Site.FileView.ExchangeExternalFileConfirmQuestion"), () => {

                                const fileInput = document.createElement('input');
                                fileInput.type = 'file';
                                fileInput.addEventListener('change', () => {
                                    const files = fileInput.files;
                                    if (files && files.length) {
                                        const formData = new FormData();
                                        formData.append('file', files[0], files[0].name);
                                        formData.append('documentId', this.entityId);
                                        serviceCall({
                                            service: 'Default/Documents/ExchangeExternalDocument',
                                            method: 'POST',
                                            request: formData,
                                            onSuccess: () => {
                                                notifySuccess(localText("Site.FileView.ExchangeExternalFileSuccess"));
                                                this.dialogClose();
                                            }
                                        });
                                    }
                                });
                                fileInput.click();
                            });
                        }
                    });
                }

                actionsToolButton({
                    toolbar: this.toolbar,
                    items: buttons
                });
            }
        })(documentsDialogProto['initToolbar']);


        documentsDialogProto['updateInterface'] = (function (old: any) {
            return function (this: DocumentsDialogExtended) {
                old.apply(this);
                this.isChangeMode = (this.isChangeMode == undefined) ? false : this.isChangeMode;
                this.element.findFirst(".RevisionInfo").hide();
                this.toolbar.findButton("start-approval-button").hide();
                this.toolbar.findButton("change-project-button").hide();
                this.toolbar.findButton("set-payment-button").hide();

                // Prüfung, ob es sich um Inbox-Dokumente handelt
                if (!this.alreadyCheckedDocumentInbox) {
                    SettingsService.IsProjectDocumentInbox({ projectId: this.entity.ProjectId }, response => {
                        this.isDocumentInbox = response.result;
                        this.alreadyCheckedDocumentInbox = true;
                        this.toolbar.updateInterface();
                    }, { async: false });
                    SettingsService.IsInvoiceDocumentInbox({ projectId: this.entity.ProjectId }, response => {
                        this.isDocumentInbox = response.result;
                        this.alreadyCheckedDocumentInbox = true;
                        this.toolbar.updateInterface();
                    }, { async: false });
                }

                if (this.entity.ExternalSource) {
                    this.form.ReleaseDate.getGridField().hide();
                    this.form.RevisionInfo.getGridField().hide();
                    EditorUtils.setReadOnly(this.form.Folder, true);
                }
                if (this.isDocumentInbox && !this.entity.WBSElementId) {
                    EditorUtils.setRequired(this.form.WBSElementId, true);
                }
                if (this.isEditMode() && this.isChangeMode) {
                    EditorUtils.setReadOnly(this.form.ProjectId, !this.isDocumentInbox);
                    EditorUtils.setReadOnly(this.form.WBSElementId, !this.isDocumentInbox);

                    if (!this.isNew() && this.entity.ProjectId) {
                        var taskItems = this.form.TasksGrid.getItems();
                        if (!taskItems || taskItems.length == 0) {
                            SettingsService.IsProjectDocumentInbox({ projectId: this.entity.ProjectId }, response => {
                                if (response.result) {
                                    EditorUtils.setReadOnly(this.form.ProjectId, true);
                                    EditorUtils.setReadOnly(this.form.WBSElementId, true);
                                    EditorUtils.setRequired(this.form.WBSElementId, true);
                                } else {
                                    EditorUtils.setReadOnly(this.form.ProjectId, true);
                                    if (this.form.WBSElementId.value == '') {
                                        EditorUtils.setReadOnly(this.form.WBSElementId, false);
                                    } else {
                                        EditorUtils.setReadOnly(this.form.WBSElementId, true);
                                    }
                                    EditorUtils.setRequired(this.form.WBSElementId, false);
                                }
                            }, { async: false });
                            SettingsService.IsInvoiceDocumentInbox({ projectId: this.entity.ProjectId }, response => {
                                if (response.result) {
                                    EditorUtils.setReadOnly(this.form.ProjectId, true);
                                    EditorUtils.setReadOnly(this.form.WBSElementId, true);
                                    EditorUtils.setRequired(this.form.WBSElementId, true);
                                } else {
                                    EditorUtils.setReadOnly(this.form.ProjectId, true);
                                    if (this.form.WBSElementId.value == '') {
                                        EditorUtils.setReadOnly(this.form.WBSElementId, false);
                                    } else {
                                        EditorUtils.setReadOnly(this.form.WBSElementId, true);
                                    }
                                    EditorUtils.setRequired(this.form.WBSElementId, false);
                                }
                            }, { async: false });
                        }
                    }
                }

                if (this.referencesExists == null) {
                    if (!this.entity.ExternalSource) {
                        this.referencesExists = false;
                        this.toolbar.updateInterface();
                    } else {
                        serviceCall({
                            service: 'Default/Documents/ReferencesExists',
                            request: {
                                DocumentId: this.entity.DocumentId
                            },
                            onSuccess: (response: any) => {
                                this.referencesExists = !!response.Value;
                                this.toolbar.updateInterface();
                            },
                            async: false
                        });
                    }
                }
                //(this.element as JQuery).find('.inv_gen_step').hide();

                if (!this.alreadyAddedReminderMilestone) {
                    this.alreadyAddedReminderMilestone = true;
                    var parentElement = this.element.findFirst(".categories").firstChild();
                    this.element.findFirst(".ReminderId").appendTo(parentElement);
                    this.element.findFirst(".MilestoneId").appendTo(parentElement);
                    this.element.findFirst(".BusinessUnitId").insertAfter(this.element.findFirst(".WBSElementId"));
                    this.element.findFirst(".ContactUnitId").insertAfter(this.element.findFirst(".BusinessUnitId"));
                    this.element.findFirst(".UsageTypeId").insertAfter(this.element.findFirst(".ContactUnitId"));
                    this.element.findFirst(".DocumentOriginTypeId").insertAfter(this.element.findFirst(".UsageTypeId"));
                    this.element.findFirst(".MilestoneId").insertAfter(this.element.findFirst(".DocumentOriginTypeId"));
                    this.element.findFirst(".ReminderId").insertAfter(this.element.findFirst(".MilestoneId"));
                    this.element.findFirst(".BusinessUnitId").removeClass("col-md-4").addClass("col-sm-6");
                    this.element.findFirst(".ContactUnitId").removeClass("col-md-4").addClass("col-sm-6");
                    this.element.findFirst(".UsageTypeId").removeClass("col-md-4").addClass("col-sm-6");
                }
                var doctype = tryFirst(TypesRow.getLookup().items,
                    x => x.DataClassName == "Document" && x.Type == "Invoice");
                // only if doctype is invoice
                if (doctype && this.entity.TypeId == doctype.TypeId) {


                    EditorUtils.setReadOnly(this.form.WBSElementId, true);
                    EditorUtils.setReadOnly(this.form.ProjectId, true);
                    EditorUtils.setReadOnly(this.form.StatusId, true);
                    EditorUtils.setReadOnly(this.form.TypeId, true);
                    if (!this.invoiceTabAlreadyAdded) {
                        this.invoiceTabAlreadyAdded = true;
                        var tabs: Fluent = Fluent(this.element.findFirst('.property-tabs').findAll("li")[3]);
                        tabs.before(<li class="nav-item" id={this.idPrefix + "TabDocumentInvoice"}><a class="nav-link" href={"#" + this.idPrefix + "PaneDocumentInvoice"} data-bs-toggle="tab" role="tab" aria-expanded="false">Invoice</a></li>);
                        var panes = this.element.findFirst('.property-tabs').nextSibling();
                        panes.prepend(<div id={this.idPrefix + "PaneDocumentInvoice"} class="tab-pane"><div id={this.idPrefix + "DocumentInvoice"} class="lazy-loading-element" style="height: 400px;"></div></div>);

                        this.invoicePropertyGrid = new PropertyGrid({
                            element: this.byId("DocumentInvoice"), ... {
                                idPrefix: this.idPrefix + "_DocumentInvoiceData_",
                                items: getForm(DocumentInvoiceDataForm.formKey),
                                localTextPrefix: "Forms." + DocumentInvoiceDataForm.formKey + ".",
                                useCategories: true
                            }
                        });


                        var invoiceResp: RetrieveResponse<DocumentInvoiceDataRow> = null;
                        if (this.entityId != null) {
                            DocumentInvoiceDataService.RetrieveByDocumentId({
                                EntityId: this.entityId
                            }, response => {
                                invoiceResp = response;
                            }, {
                                async: false
                            });
                        }

                        this.documentsInvoiceForm = new DocumentInvoiceDataForm(this.invoicePropertyGrid.get_idPrefix());
                        (this.documentsInvoiceForm.DocumentTransactions as any).Value = invoiceResp?.Entity?.DocumentInvoiceDataId;
                        this.documentsInvoiceForm.DocumentTransactions.refresh();
                        // Filter CostElements by InvoiceDataId
                        this.documentsInvoiceForm.CostElements.InvoiceDataId = invoiceResp?.Entity?.DocumentInvoiceDataId;
                        this.documentsInvoiceForm.CostElements.refresh();

                        this.invoicePropertyGrid.load(invoiceResp?.Entity ?? {});
                    }
                    // If Invoice and in preparation then set invoice fields mandatory
                    var invoiceData;
                    DocumentInvoiceDataService.RetrieveByDocumentId(
                        { EntityId: this.entityId },
                        response => {
                            invoiceData = response.Entity
                        }, { async: false });

                    if (this.invoiceTabAlreadyAdded && !this.isDocumentInbox && this.entity.Status == "Inbox" && this.isEditMode()) {
                        // Set invoice fields to required
                        const doctype = tryFirst(TypesRow.getLookup().items,
                            x => x.DataClassName == "Document" && x.Type == "Invoice");
                        var invStatusId = tryFirst(StatusRow.getLookup().items,
                            x => x.DataClassName == "Invoice" && x.Status == "In Preparation");

                        if (doctype != null && this.entity.TypeId == doctype.TypeId && invoiceData.InvoiceStatusId == invStatusId.StatusId) {
                            EditorUtils.setRequired(this.documentsInvoiceForm.InvoiceNo, true);
                            EditorUtils.setRequired(this.documentsInvoiceForm.InvoiceDate, true);
                            EditorUtils.setRequired(this.documentsInvoiceForm.InvoiceDescription, true);
                            EditorUtils.setRequired(this.documentsInvoiceForm.PaymentDueDate, true);
                            EditorUtils.setRequired(this.documentsInvoiceForm.NetValue, true);
                            EditorUtils.setRequired(this.documentsInvoiceForm.GrossValue, true);
                            //EditorUtils.setRequired(this.documentsInvoiceForm.DiscountRate, true);
                            //EditorUtils.setRequired(this.documentsInvoiceForm.DiscountDate, true);
                            EditorUtils.setRequired(this.documentsInvoiceForm.PaymentTypeId, true);
                            EditorUtils.setRequired(this.documentsInvoiceForm.InvoiceTypeId, true);
                        }
                    }
                    if (this.invoiceTabAlreadyAdded && this.entity.Status == "Inbox" && this.isEditMode()) {
                        // Set invoice fields to read only

                        var invStatusId = tryFirst(StatusRow.getLookup().items,
                            x => x.DataClassName == "Invoice" && x.Status == "In Preparation");

                        if (doctype != null && this.entity.TypeId == doctype.TypeId && invoiceData.InvoiceStatusId != invStatusId.StatusId) {
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.InvoiceStatusId, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.InvoiceNo, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.InvoiceDate, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.InvoiceDescription, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.PaymentDueDate, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.NetValue, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.GrossValue, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.DiscountRate, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.DiscountDate, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.PaymentTypeId, true);
                            EditorUtils.setReadOnly(this.documentsInvoiceForm.InvoiceTypeId, true);
                        }
                    }
                    if (this.invoiceTabAlreadyAdded) {
                        undoMadeReadOnly(this.documentsInvoiceForm.DocumentTransactions.element.closest('.tab-pane'));
                        if (!this.isChangeMode && this.isEditMode()) {
                            makeReadOnly(this.documentsInvoiceForm.DocumentTransactions.element.closest('.tab-pane'));
                            undoMadeReadOnly(this.documentsInvoiceForm.DocumentTransactions.element);
                            undoMadeReadOnly(this.documentsInvoiceForm.CostElements.element);
                        }
                        this.byId("TabDocumentInvoice").toggle(this.entity.Type == "Invoice")
                    }
                    /*
                    var invoiceData;
                    DocumentInvoiceDataService.RetrieveByDocumentId(
                        { EntityId: this.entityId },
                        response => {
                            invoiceData = <DocumentInvoiceDataRow>response.Entity
                        }, { async: false });
                        */
                    // Make special buttons visible as per status
                    if (this.invoiceTabAlreadyAdded && !this.isDocumentInbox && this.entity.Status == "Inbox"
                        && this.entity.Type == "Invoice"
                        && (invoiceData.InvoiceStatusName == "In Preparation" || invoiceData.InvoiceStatusName == "Declined")
                        && invoiceData.InvoiceNo != null && invoiceData.GrossValue != null
                        && invoiceData.InvoiceDate != null
                        && invoiceData.PaymentDueDate != null && invoiceData.InvoiceTypeId != null
                        && this.entity.BusinessUnitId != null
                        && invoiceData.TasksInApproval == 0
                        && this.entity.WBSElementId != null) {
                        this.toolbar.findButton("start-approval-button").show();
                    } else {
                        this.toolbar.findButton("start-approval-button").hide();
                    }
                    if (this.invoiceTabAlreadyAdded && this.isDocumentInbox && this.entity.Status == "Inbox"
                        && this.entity.Type == "Invoice"
                        && invoiceData.InvoiceStatusName == "Inbox") {
                        this.toolbar.findButton("change-project-button").show();
                    } else {
                        this.toolbar.findButton("change-project-button").hide();
                    }
                    if (this.invoiceTabAlreadyAdded && !this.isDocumentInbox
                        && this.entity.Type == "Invoice"
                        && invoiceData.InvoiceStatusName == "Approved") {
                        this.toolbar.findButton("set-payment-button").show();
                    } else {
                        this.toolbar.findButton("set-payment-button").hide();
                    }
                    if (this.invoiceTabAlreadyAdded && !this.isDocumentInbox
                        && this.entity.Type == "Invoice"
                        && (invoiceData.InvoiceStatusName == "Paid" || invoiceData.InvoiceStatusName == "Approved" || invoiceData.InvoiceStatusName == "In Approval")) {
                        this.toolbar.findButton("edit-mode-button").hide();
                    }
                    EditorUtils.setReadOnly(this.documentsInvoiceForm.InvoiceStatusId, true);
                }
                if (this.isNew() && !this.entity.ProjectId) {
                    EditorUtils.setReadOnly(this.form.ProjectId, false);
                    EditorUtils.setReadOnly(this.form.WBSElementId, false)
                }

                if (this.entity.ExternalId) {
                    this.element.findFirst(".btn-file-name-change").hide();
                }

                if (this.invoiceTabAlreadyAdded) {
                    var invoiceData;
                    DocumentInvoiceDataService.RetrieveByDocumentId(
                        { EntityId: this.entityId },
                        response => {
                            invoiceData = response.Entity
                        }, { async: false });
                    var tb = this.byId('Toolbar');
                    if (this.element.findFirst("#inv_workflow_info").length) {
                        this.element.findFirst("#inv_workflow_info").remove();
                    }
                    if (invoiceData.InvoiceStatusName == "Inbox") {
                        tb.append(<div class="inv_wf_status" id="inv_workflow_info">{tryGetText('Site.DocumentsInvoiceWorkflow.InfoInbox')}</div>);
                    } else if (invoiceData.InvoiceStatusName == "In Preparation") {
                        tb.append(<div class="inv_wf_status" id="inv_workflow_info">{tryGetText('Site.DocumentsInvoiceWorkflow.InfoInPreparation')}</div>);
                    } else if (invoiceData.InvoiceStatusName == "In Approval") {
                        tb.append(<div class="inv_wf_status" id="inv_workflow_info">{tryGetText('Site.DocumentsInvoiceWorkflow.InfoInApproval')}</div>);
                    } else if (invoiceData.InvoiceStatusName == "Approved") {
                        tb.append(<div class="inv_wf_status" id="inv_workflow_info">{tryGetText('Site.DocumentsInvoiceWorkflow.InfoApproved')}</div>);
                    } else if (invoiceData.InvoiceStatusName == "Declined") {
                        tb.append(<div class="inv_wf_status" id="inv_workflow_info">{tryGetText('Site.DocumentsInvoiceWorkflow.InfoDeclined')}</div>);
                    } else if (invoiceData.InvoiceStatusName == "Paid") {
                        tb.append(<div class="inv_wf_status" id="inv_workflow_info">{tryGetText('Site.DocumentsInvoiceWorkflow.InfoPaid')}</div>);
                    } else if (invoiceData.InvoiceStatusName == "On Hold") {
                        tb.append(<div class="inv_wf_status" id="inv_workflow_info">{tryGetText('Site.DocumentsInvoiceWorkflow.InfoOnHold')}</div>);
                    }
                }
            }

        })(documentsDialogProto['updateInterface']);

        documentsDialogProto['getSaveEntity'] = (function (old) {
            return function (this: DocumentsDialogExtended) {
                var entity = old.apply(this);
                if (this.documentsInvoiceForm) {
                    // If document is invoice, create DocumentInvoiceData if not exists
                    var invStatusId = tryFirst(StatusRow.getLookup().items,
                        x => x.DataClassName == "Invoice" && x.Status == "Inbox");
                    var invoiceData: DocumentInvoiceDataRow = {};
                    (this.invoicePropertyGrid as PropertyGrid).save(invoiceData);

                    if (!invoiceData.InvoiceStatusId) {
                        invoiceData.InvoiceStatusId = invStatusId.StatusId;
                    }
                    if (this.documentsInvoiceForm.DocumentInvoiceDataId.value) {
                        DocumentInvoiceDataService.Update({
                            EntityId: this.documentsInvoiceForm.DocumentInvoiceDataId.value,
                            Entity: invoiceData
                        });

                    } else if (this.entityId) {
                        invoiceData.DocumentId = this.entityId;
                        var DocInvDataId = DocumentInvoiceDataService.Create({
                            Entity: invoiceData
                        });

                    }
                }
                return entity;
            }
        })(documentsDialogProto['getSaveEntity']);


        documentsDialogProto['getLoadByIdRequest'] = (function (old) {
            return function (this: DocumentsDialogExtended, id) {
                var request = old.apply(this, [id]);
                request.IncludeColumns = request.IncludeColumns || [];
                request.IncludeColumns.push(DocumentsRow.Fields.TransactionId);
                return request;
            }
        })(documentsDialogProto['getLoadByIdRequest']);

        documentsDialogProto['onSaveSuccess'] = (function (old) {
            return function (this: DocumentsDialogExtended, response) {
                old.apply(this, response);
                if (this.documentsInvoiceForm) {
                    /*
                    DocumentsInvoiceWorkflowService.Update({
                        Entity: {
                            DocumentId: this.entity.DocumentId,
                            InvoiceStatusId: this.entity.InvoiceStatusId,
                            TypeId: this.entity.TypeId,
                            WBSElementId: this.entity.WBSElementId
                        },
                        EntityId: this.entity.DocumentId
                    }, () => {
                            });
                            */
                }
                //if (this.documentsInvoiceForm) {
                //    if (this.documentsInvoiceForm.TransactionId.value)
                //        BankAccountTransactionsService.Update({
                //            EntityId: toId(this.documentsInvoiceForm.TransactionId.value),
                //            Entity: {
                //                BankAccountTransactionId: toId(this.documentsInvoiceForm.TransactionId.value),
                //                InvoiceDocumentId: response.EntityId
                //            }
                //        }, () => {

                //        });
                //    if (this.entity.TransactionId && ((!this.documentsInvoiceForm.TransactionId.value && this.entity.TransactionId) || toId(this.documentsInvoiceForm.TransactionId.value) != this.entity.TransactionId)) {
                //        BankAccountTransactionsService.Update({
                //            EntityId: this.entity.TransactionId,
                //            Entity: {
                //                BankAccountTransactionId: toId(this.entity.TransactionId),
                //                InvoiceDocumentId: null
                //            }
                //        }, () => {

                //        });
                //    }
                //    this.documentsInvoiceForm.TransactionId.updateItems();
                //}

            }
        })(documentsDialogProto['onSaveSuccess']);
    }

    const gridProto = (getType("Cemdo.DocumentManagement.DocumentGrid") as any)?.prototype;

    if (gridProto) {
        gridProto['getQuickFilters'] = (function (old) {
            return function (this: DocumentsGridExtended) {
                var filters = old.call(this);
                if (this.options && this.options.excludeFilter && any(this.options.excludeFilter, x => x == "FunctionalUnitId"))
                    return filters;
                filters.push({
                    type: LookupEditor,
                    field: "functionalUnitFilter",
                    options: {
                        lookupKey: FunctionalUnitsRow.lookupKey
                    },
                    title: localText("Db.Administration.FunctionalUnits.EntitySingular"),
                    handler: w => {
                        if (w.active) {
                            w.request.Criteria = Criteria.and(w.request.Criteria,
                                [["FunctionalUnitId"], "=", w.value]);
                        }
                    },
                    init: e => {
                        var widget = e.element.getWidget(LookupEditor);
                        if (Authorization.userDefinition.HasDefaultTeamFilter)
                            widget.value = Authorization.userDefinition.MainFunctionalUnitId?.toString();
                    }
                });
                return filters;
            }
        })(gridProto['getQuickFilters']);
    }

    const gridInvoiceWorkflow = DocumentsInvoiceWorkflowGrid.prototype;
    gridInvoiceWorkflow['getQuickSearchFields'] = (function (old) {
        return function (this: any) {
            var filters = old.call(this);
            return [
                {
                    name: "Filename",
                    title: "File"
                }, {
                    name: "ProjectKeyword",
                    title: "Project"
                }, {
                    name: "PartnerName",
                    title: "Debitor"
                }, {
                    name: "InvoiceDescription",
                    title: "Invoice Desc."
                }
            ];
        }
    })(gridInvoiceWorkflow['getQuickSearchFields']);

    const gridInvoiceInboxWorkflow = DocumentsInvoiceWorkflowInboxGrid.prototype;
    gridInvoiceInboxWorkflow['getQuickSearchFields'] = (function (old) {
        return function (this: any) {
            return [
                {
                    name: "Filename",
                    title: "File"
                }, {
                    name: "ProjectKeyword",
                    title: "Project"
                }, {
                    name: "PartnerName",
                    title: "Debitor"
                }
            ];
        }
    })(gridInvoiceInboxWorkflow['getQuickSearchFields']);

}
